"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.JSONRPC = exports.MULTICHAIN_URLS = void 0;
const axios_1 = __importDefault(require("axios"));
const timeout_1 = require("./timeout");
exports.MULTICHAIN_URLS = {
    BTC: "https://multichain.renproject.io/mainnet/bitcoind",
    BTCTEST: "https://multichain-staging.renproject.io/testnet/bitcoind",
    ZEC: "https://multichain.renproject.io/mainnet/zcashd",
    ZECTEST: "https://multichain-staging.renproject.io/testnet/zcashd",
    BCH: "https://multichain.renproject.io/mainnet/bitcoincashd",
    BCHTEST: "https://multichain-staging.renproject.io/testnet/bitcoincashd",
};
const broadcastTransaction = (url) => async (txHex) => {
    const response = await axios_1.default.post(url, {
        jsonrpc: "1.0",
        id: "67",
        method: "sendrawtransaction",
        params: [txHex],
    }, { timeout: timeout_1.DEFAULT_TIMEOUT });
    return response.data.result;
};
exports.JSONRPC = {
    broadcastTransaction,
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoianNvbnJwYy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9jb21tb24vYXBpcy9qc29ucnBjLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7OztBQUFBLGtEQUEwQjtBQUMxQix1Q0FBNEM7QUFFL0IsUUFBQSxlQUFlLEdBQUc7SUFDM0IsR0FBRyxFQUFFLG1EQUFtRDtJQUN4RCxPQUFPLEVBQUUsMkRBQTJEO0lBQ3BFLEdBQUcsRUFBRSxpREFBaUQ7SUFDdEQsT0FBTyxFQUFFLHlEQUF5RDtJQUNsRSxHQUFHLEVBQUUsdURBQXVEO0lBQzVELE9BQU8sRUFBRSwrREFBK0Q7Q0FDM0UsQ0FBQztBQUVGLE1BQU0sb0JBQW9CLEdBQUcsQ0FBQyxHQUFXLEVBQUUsRUFBRSxDQUFDLEtBQUssRUFDL0MsS0FBYSxFQUNFLEVBQUU7SUFDakIsTUFBTSxRQUFRLEdBQUcsTUFBTSxlQUFLLENBQUMsSUFBSSxDQUs3QixHQUFHLEVBQ0g7UUFDSSxPQUFPLEVBQUUsS0FBSztRQUNkLEVBQUUsRUFBRSxJQUFJO1FBQ1IsTUFBTSxFQUFFLG9CQUFvQjtRQUM1QixNQUFNLEVBQUUsQ0FBQyxLQUFLLENBQUM7S0FDbEIsRUFDRCxFQUFFLE9BQU8sRUFBRSx5QkFBZSxFQUFFLENBQy9CLENBQUM7SUFDRixPQUFPLFFBQVEsQ0FBQyxJQUFJLENBQUMsTUFBTSxDQUFDO0FBQ2hDLENBQUMsQ0FBQztBQUVXLFFBQUEsT0FBTyxHQUFHO0lBQ25CLG9CQUFvQjtDQUN2QixDQUFDIn0=